import { placeholders, displayGroups } from '@ui';

import { TouchPointHelper } from '../../../helpers/touchPointHelper';

export const serviceError = {
	prismName: 'serviceError',
	template: {
		templateName: 'ServiceErrorTemplate',
		displayGroups: [
			TouchPointHelper.createDisplayGroup(
				displayGroups.pageContainer,
				[
					TouchPointHelper.createDisplayGroup(
						displayGroups.columnContainer,
						[],
						[
							TouchPointHelper.createPlaceholder(placeholders.serviceError, {
								placeholderBuildReference: 1,
							}),
						]
					),
				],
				[]
			),
		],
	},
};
